import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "../pages/home/page";
import ArticleGuide from "@/pages/article/guide/page";
import SafetyGuide from "@/pages/article/safety/page";
import BeginnerTutorial from "@/pages/article/beginner/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-spreadsheet-complete-guide",
    element: <ArticleGuide />,
  },
  {
    path: "/superbuy-spreadsheet-safety-guide",
    element: <SafetyGuide />,
  },
  {
    path: "/superbuy-spreadsheet-beginner-tutorial",
    element: <BeginnerTutorial />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;